import { EMPTY_ARRAY, IApplicationState } from '../../../../../../../types/types';
import { IBoard } from '../types';

export const getBoards = (
    state: IApplicationState
): IBoard[] => {
    return state.openBoardsDialog && state.openBoardsDialog.boards && state.openBoardsDialog.boards.boards || EMPTY_ARRAY;
}
